/**
 * Given a URL, return a normalized version used for image dimension caching
 *
 * This will remove all cloudinary arguments and will include, in a consistent
 * way, the height and/or width if the image is being cropped.
 *
 * @param {string} url URL to normalize
 */
export function normalizeImageURLForImageAspectRatioCache(url) {
  const [cloudinaryCrop] = url.match(/\b(c_crop)\b/) || [];
  let resolutionChangingFields = [cloudinaryCrop];

  // If the image is being cropped, then take the height and width into account
  if (cloudinaryCrop != null) {
    const [cloudinaryHeight] = url.match(/\b(h_[\d+.]+)\b/) || [];
    const [cloudinaryWidth] = url.match(/\b(w_[\d+.]+)\b/) || [];

    // We're putting the fields into the array in a consistent order, therefore
    // they don't need to be sorted.
    resolutionChangingFields = resolutionChangingFields.concat(
      cloudinaryHeight,
      cloudinaryWidth,
    );
  }

  resolutionChangingFields = resolutionChangingFields.filter(Boolean);
  const suffix =
    resolutionChangingFields.length > 0
      ? `|${resolutionChangingFields.join("|")}`
      : "";

  const stripCloudinaryRegex = /^.*?verse-api-av-output-files.s3.amazonaws.com/;
  const result = url.replace(stripCloudinaryRegex, "") + suffix;

  return result;
}
